import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Product from './main/product';
import ColdCoffee from './main/frappe';
import Milkshakes from './main/milkshake';
import Hotchocolate from './main/hotc';
import Mocktail from './main/mocktail';
import Rocks from './main/rocks';
import AppCoffee from './main/ap';
import Home from './main/home';
import Footer from './main/footer';
import NavigationBar from './main/nav';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppCoffee/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
